import * as React from "react";
const NewsRightBold2 = (props) => (
  <svg
    width={props.width}
    height={props.height}
    viewBox="0 0 16 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M2 2L14 14L2 26"
      stroke="white"
      strokeWidth={props.font}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2 2L14 14L2 26"
      stroke="white"
      strokeWidth={props.font}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default NewsRightBold2;
